export default "__VITE_ASSET__DHvvsQOE__"